export const authMeta = {
  requiresAuth: true
};
export const eventMeta = {
  requiresEvent: true
};
